var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-marker',{ref:"marker",attrs:{"lat-lng":_vm.latLng,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }